import { useState } from 'react';
import type { AdminTask } from '../../types';
import AdminDrawer from '../AdminDrawer';

const tasks: AdminTask[] = [
  { id: 'T-041', title: 'Nahrať reklamné sady Facebook',        client: 'TechFlow',            project: 'Facebook Ads kampaň',      priority: 'high',   status: 'open',        assignee: 'PH', due: '31.3.2025' },
  { id: 'T-042', title: 'SEO audit Q1',                         client: 'Bratislava Pet Shop', project: 'Google Ads Q2',            priority: 'high',   status: 'in_progress', assignee: 'MK', due: '2.4.2025'  },
  { id: 'T-043', title: 'Schváliť dizajn landing page',         client: 'VitaBenefit',         project: 'E-shop redesign',          priority: 'medium', status: 'open',        assignee: 'TN', due: '5.4.2025'  },
  { id: 'T-044', title: 'Texty pre Google Ads kreatívy',        client: 'MotoLux SK',          project: 'Web + SEO',                priority: 'medium', status: 'open',        assignee: 'JS', due: '7.4.2025'  },
  { id: 'T-045', title: 'Mesačný report – márc',                client: 'Petra K.',            project: 'Instagramová komunikácia', priority: 'high',   status: 'in_progress', assignee: 'MK', due: '5.4.2025'  },
  { id: 'T-046', title: 'Optimalizácia PPC kampaní',            client: 'TechFlow',            project: 'Scale – Full stack mktg',  priority: 'medium', status: 'in_progress', assignee: 'PH', due: '10.4.2025' },
  { id: 'T-047', title: 'Zaslať návrh webu klientovi',          client: 'VitaBenefit',         project: 'E-shop redesign',          priority: 'low',    status: 'open',        assignee: 'TN', due: '12.4.2025' },
  { id: 'T-048', title: 'Copywriting – About stránka',          client: 'MotoLux SK',          project: 'Web + SEO',                priority: 'low',    status: 'open',        assignee: 'JS', due: '15.4.2025' },
  { id: 'T-049', title: 'Integrácia Analytics & Search Console', client: 'Bratislava Pet Shop', project: 'Nový web Pet Shop',       priority: 'medium', status: 'in_progress', assignee: 'TN', due: '20.4.2025' },
  { id: 'T-050', title: 'Nastaviť Google Tag Manager',          client: 'JH Legal',            project: 'Scale – Full stack mktg',  priority: 'high',   status: 'open',        assignee: 'MK', due: '3.4.2025'  },
  { id: 'T-051', title: 'Záverečná kontrola pred live',         client: 'VitaBenefit',         project: 'E-shop redesign',          priority: 'high',   status: 'open',        assignee: 'TN', due: '9.4.2025'  },
  { id: 'T-052', title: 'Pridať blog sekciu – 3 články',        client: 'FreshAir s.r.o.',     project: 'Web + SEO',                priority: 'low',    status: 'open',        assignee: 'JS', due: '25.4.2025' },
  { id: 'T-053', title: 'A/B test bannery – verzia B',          client: 'TechFlow',            project: 'Facebook Ads kampaň',      priority: 'medium', status: 'done',        assignee: 'PH', due: '28.3.2025' },
  { id: 'T-054', title: 'Spustenie remarketingovej kamp.',      client: 'Bratislava Pet Shop', project: 'Google Ads Q2',            priority: 'high',   status: 'done',        assignee: 'PH', due: '25.3.2025' },
];

const taskDesc: Record<string, string> = {
  'T-041': 'Pripraviť a nahrať všetky sady reklamných obrázkov a videí do Facebook Ads Managera. Formáty: 1:1, 4:5, 9:16. Každá sada min. 3 varianty textu.',
  'T-042': 'Komplexný SEO audit webu – technický audit, on-page analýza, analýza spätných odkazov. Výstup: PDF report s odporúčaniami.',
  'T-043': 'Klient musí schváliť finálny dizajn landing page v Figme. Link na prototype odoslaný. Čaká sa na spätnú väzbu.',
  'T-044': 'Napísať 5 variánt headline a description textov pre kampane na produktové kategórie. Zohľadniť USP klienta.',
  'T-045': 'Mesačný report za marec – Instagram výsledky, reach, engagement, story views, follower growth. Formát: PDF + komentár.',
  'T-046': 'Optimalizácia biddingu a negatívnych kľúčových slov v PPC kampaniach na základe dát za Q1.',
  'T-047': 'Poslať Figma prototype e-shopu klientovi cez portál. Priložiť sprievodný komentár k dizajnovým rozhodnutiam.',
  'T-048': 'Napísať texty pre stránku O nás – história firmy, tím, hodnoty. Rozsah cca 400 slov.',
  'T-049': 'Prepojiť Google Analytics 4 a Search Console s webom. Overiť správnosť trackingu konverzií.',
  'T-050': 'Implementovať Google Tag Manager na web klienta. Nastaviť základné tagy: GA4, Meta Pixel, LinkedIn Insight.',
  'T-051': 'Záverečná kontrola pred spustením: linky, formuláre, mobilná verzia, rýchlosť (Core Web Vitals), SSL.',
  'T-052': 'Napísať 3 blogové články na témy: čistenie vzduchu, filtrácia, energetická úspornosť. Každý min. 600 slov, SEO optimalizovaný.',
  'T-053': 'Spustiť A/B test verzie B reklamných bannerov. Porovnať CTR s verziou A po 7 dňoch.',
  'T-054': 'Spustiť remarketingovú kampaň na návštevníkov košíka za posledných 30 dní. Budget 200 €/mesiac.',
};

const taskActivity: Record<string, { from: string; text: string; time: string }[]> = {
  'T-041': [{ from: 'PH', text: 'Začínam pripravovať podklady.', time: '29.3. 10:05' }],
  'T-042': [{ from: 'MK', text: 'Audit prebieha, zatiaľ nájdené 3 kritické problémy.', time: '1.4. 9:22' }, { from: 'Admin', text: 'Skontroluj aj Core Web Vitals!', time: '1.4. 11:00' }],
  'T-043': [{ from: 'TN', text: 'Link na prototype odoslaný klientovi.', time: '3.4. 14:30' }],
  'T-045': [{ from: 'MK', text: 'Prvý draft reportu hotový, posielam na kontrolu.', time: '4.4. 16:00' }],
  'T-046': [{ from: 'PH', text: 'Identifikovaných 12 negatívnych kľúčových slov na pridanie.', time: '2.4. 13:15' }],
  'T-049': [{ from: 'TN', text: 'GA4 pripojené, testujem konverzie.', time: '3.4. 11:45' }, { from: 'Admin', text: 'Super! Skontroluj aj ecommerce tracking.', time: '3.4. 12:00' }],
};

const priorityStyle: Record<AdminTask['priority'], string> = {
  high:   'bg-red-500/10 text-red-400 border-red-500/20',
  medium: 'bg-amber-500/10 text-amber-400 border-amber-500/20',
  low:    'bg-zinc-700/40 text-zinc-500 border-zinc-600/30',
};
const priorityLabel: Record<AdminTask['priority'], string> = { high: 'Urgentná', medium: 'Stredná', low: 'Nízka' };
const statusStyle: Record<AdminTask['status'], string> = {
  open:        'bg-zinc-800 text-zinc-400',
  in_progress: 'bg-sky-500/10 text-sky-400 border border-sky-500/20',
  done:        'bg-emerald-500/10 text-emerald-400 border border-emerald-500/20',
};
const statusLabel: Record<AdminTask['status'], string> = { open: 'Otvorená', in_progress: 'Prebieha', done: 'Hotovo' };
const assigneeColors: Record<string, string> = { PH: 'bg-sky-600', MK: 'bg-violet-600', TN: 'bg-teal-600', JS: 'bg-pink-600' };
const assigneeNames: Record<string, string> = { PH: 'Patrik Horváth', MK: 'Marek Kováč', TN: 'Tomáš Novák', JS: 'Jana Slováková' };

export default function AdminUlohy() {
  const [statusFilter, setStatusFilter] = useState<'all' | AdminTask['status']>('all');
  const [priorityFilter, setPriorityFilter] = useState<'all' | AdminTask['priority']>('all');
  const [search, setSearch] = useState('');
  const [selected, setSelected] = useState<AdminTask | null>(null);
  const [taskStatuses, setTaskStatuses] = useState<Record<string, AdminTask['status']>>({});
  const [newComment, setNewComment] = useState('');
  const [comments, setComments] = useState<Record<string, { from: string; text: string; time: string }[]>>(taskActivity);

  const getStatus = (t: AdminTask): AdminTask['status'] => taskStatuses[t.id] ?? t.status;

  const filtered = tasks.filter((t) => {
    const q = search.toLowerCase();
    return (t.title.toLowerCase().includes(q) || t.client.toLowerCase().includes(q))
      && (statusFilter === 'all' || getStatus(t) === statusFilter)
      && (priorityFilter === 'all' || t.priority === priorityFilter);
  });

  const changeStatus = (id: string, s: AdminTask['status']) => {
    setTaskStatuses((prev) => ({ ...prev, [id]: s }));
    if (selected?.id === id) setSelected((prev) => prev ? { ...prev } : null);
  };

  const sendComment = () => {
    if (!newComment.trim() || !selected) return;
    setComments((prev) => ({
      ...prev,
      [selected.id]: [...(prev[selected.id] ?? []), { from: 'Admin', text: newComment.trim(), time: 'Teraz' }],
    }));
    setNewComment('');
  };

  return (
    <div className="h-full overflow-y-auto p-6 space-y-4">
      {/* Filters */}
      <div className="flex items-center gap-3">
        <div className="flex items-center gap-2 bg-zinc-900 border border-zinc-800 rounded-xl px-3 py-2 flex-1 max-w-xs">
          <i className="ri-search-line text-zinc-500 text-sm" />
          <input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Hľadať úlohu..." className="bg-transparent text-zinc-300 text-sm placeholder:text-zinc-600 outline-none flex-1" />
        </div>
        <div className="flex items-center gap-1 bg-zinc-900 border border-zinc-800 rounded-xl p-1">
          {(['all', 'open', 'in_progress', 'done'] as const).map((s) => (
            <button key={s} onClick={() => setStatusFilter(s)} className={`px-3 py-1.5 rounded-lg text-xs font-medium transition-all cursor-pointer whitespace-nowrap ${statusFilter === s ? 'bg-zinc-700 text-zinc-200' : 'text-zinc-500 hover:text-zinc-300'}`}>
              {s === 'all' ? 'Všetky' : statusLabel[s]}
            </button>
          ))}
        </div>
        <div className="flex items-center gap-1 bg-zinc-900 border border-zinc-800 rounded-xl p-1">
          {(['all', 'high', 'medium', 'low'] as const).map((p) => (
            <button key={p} onClick={() => setPriorityFilter(p)} className={`px-3 py-1.5 rounded-lg text-xs font-medium transition-all cursor-pointer whitespace-nowrap ${priorityFilter === p ? 'bg-zinc-700 text-zinc-200' : 'text-zinc-500 hover:text-zinc-300'}`}>
              {p === 'all' ? 'Priorita' : priorityLabel[p]}
            </button>
          ))}
        </div>
        <div className="flex-1" />
        <button className="flex items-center gap-2 bg-orange-500 hover:bg-orange-600 text-white text-xs font-semibold px-4 py-2 rounded-xl transition-all cursor-pointer whitespace-nowrap">
          <i className="ri-add-line text-sm" /> Nová úloha
        </button>
      </div>

      {/* Table */}
      <div className="bg-zinc-900 border border-zinc-800 rounded-2xl overflow-hidden">
        <table className="w-full">
          <thead>
            <tr className="border-b border-zinc-800">
              {['ID', 'Úloha', 'Klient · Projekt', 'Riešiteľ', 'Priorita', 'Splatnosť', 'Stav', ''].map((h) => (
                <th key={h} className="text-left px-4 py-3 text-zinc-600 text-[11px] font-semibold uppercase tracking-wider first:pl-5">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-zinc-800">
            {filtered.map((t) => {
              const curStatus = getStatus(t);
              return (
                <tr key={t.id} onClick={() => setSelected(t)} className={`hover:bg-zinc-800/40 cursor-pointer transition-all group ${curStatus === 'done' ? 'opacity-50' : ''}`}>
                  <td className="px-4 pl-5 py-3"><span className="text-zinc-600 text-[10px] font-mono">{t.id}</span></td>
                  <td className="px-4 py-3">
                    <p className={`text-zinc-200 text-sm font-medium group-hover:text-orange-300 transition-colors ${curStatus === 'done' ? 'line-through text-zinc-600' : ''}`}>{t.title}</p>
                  </td>
                  <td className="px-4 py-3">
                    <p className="text-zinc-400 text-xs font-medium">{t.client}</p>
                    <p className="text-zinc-600 text-[10px]">{t.project}</p>
                  </td>
                  <td className="px-4 py-3">
                    <div className={`w-7 h-7 rounded-lg ${assigneeColors[t.assignee] ?? 'bg-zinc-600'} flex items-center justify-center`}>
                      <span className="text-white text-[10px] font-bold">{t.assignee}</span>
                    </div>
                  </td>
                  <td className="px-4 py-3">
                    <span className={`text-[10px] font-semibold px-2 py-0.5 rounded-full border ${priorityStyle[t.priority]}`}>{priorityLabel[t.priority]}</span>
                  </td>
                  <td className="px-4 py-3"><span className="text-zinc-500 text-xs">{t.due}</span></td>
                  <td className="px-4 py-3">
                    <span className={`text-[10px] font-semibold px-2.5 py-1 rounded-lg ${statusStyle[curStatus]}`}>{statusLabel[curStatus]}</span>
                  </td>
                  <td className="px-4 py-3">
                    <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-zinc-800 opacity-0 group-hover:opacity-100 transition-opacity">
                      <i className="ri-arrow-right-line text-zinc-400 text-sm" />
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {filtered.length === 0 && (
          <div className="text-center py-12">
            <i className="ri-task-line text-zinc-700 text-3xl" />
            <p className="text-zinc-600 text-sm mt-2">Žiadne úlohy nevyhovujú filtru</p>
          </div>
        )}
      </div>

      {/* Task detail drawer */}
      {selected && (() => {
        const curStatus = getStatus(selected);
        const acts = comments[selected.id] ?? [];
        return (
          <AdminDrawer
            open={!!selected}
            onClose={() => setSelected(null)}
            title={selected.title}
            subtitle={`${selected.client} · ${selected.project}`}
            icon="ri-task-line"
            iconBg={assigneeColors[selected.assignee] ?? 'bg-zinc-700'}
          >
            <div className="p-5 space-y-5">
              {/* Meta info grid */}
              <div className="grid grid-cols-2 gap-2">
                {[
                  { label: 'ID',         value: selected.id,                          icon: 'ri-hashtag'         },
                  { label: 'Riešiteľ',   value: assigneeNames[selected.assignee] ?? selected.assignee, icon: 'ri-user-line' },
                  { label: 'Splatnosť',  value: selected.due,                         icon: 'ri-calendar-line'   },
                  { label: 'Priorita',   value: priorityLabel[selected.priority],     icon: 'ri-flag-line'       },
                ].map((d) => (
                  <div key={d.label} className="bg-zinc-800/50 rounded-xl p-3">
                    <div className="flex items-center gap-1.5 mb-1">
                      <i className={`${d.icon} text-zinc-600 text-xs`} />
                      <p className="text-zinc-600 text-[10px] uppercase tracking-wider font-semibold">{d.label}</p>
                    </div>
                    <p className="text-zinc-200 text-xs font-medium">{d.value}</p>
                  </div>
                ))}
              </div>

              {/* Status change */}
              <div>
                <p className="text-zinc-600 text-[10px] font-bold uppercase tracking-widest mb-2">Zmeniť stav</p>
                <div className="flex gap-2">
                  {(['open', 'in_progress', 'done'] as const).map((s) => (
                    <button
                      key={s}
                      onClick={() => changeStatus(selected.id, s)}
                      className={`flex-1 py-2 rounded-xl text-xs font-semibold transition-all cursor-pointer whitespace-nowrap border ${curStatus === s ? statusStyle[s] + ' border-current' : 'bg-zinc-800/50 text-zinc-600 border-zinc-700 hover:text-zinc-300'}`}
                    >
                      {statusLabel[s]}
                    </button>
                  ))}
                </div>
              </div>

              {/* Description */}
              <div>
                <p className="text-zinc-600 text-[10px] font-bold uppercase tracking-widest mb-2">Popis úlohy</p>
                <div className="bg-zinc-800/40 rounded-xl p-3">
                  <p className="text-zinc-400 text-xs leading-relaxed">{taskDesc[selected.id] ?? 'Žiadny popis.'}</p>
                </div>
              </div>

              {/* Activity / comments */}
              <div>
                <p className="text-zinc-600 text-[10px] font-bold uppercase tracking-widest mb-2">Aktivita & komentáre</p>
                <div className="space-y-2 mb-3">
                  {acts.length === 0 && (
                    <p className="text-zinc-700 text-xs">Zatiaľ žiadne komentáre.</p>
                  )}
                  {acts.map((a, i) => (
                    <div key={i} className="flex items-start gap-2.5">
                      <div className={`w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 ${a.from === 'Admin' ? 'bg-orange-500' : assigneeColors[a.from] ?? 'bg-zinc-600'}`}>
                        <span className="text-white text-[9px] font-bold">{a.from.slice(0,2)}</span>
                      </div>
                      <div className="bg-zinc-800/50 rounded-xl px-3 py-2 flex-1">
                        <div className="flex items-center justify-between mb-0.5">
                          <span className="text-zinc-400 text-[10px] font-semibold">{a.from === 'Admin' ? 'Ty' : assigneeNames[a.from] ?? a.from}</span>
                          <span className="text-zinc-700 text-[10px]">{a.time}</span>
                        </div>
                        <p className="text-zinc-300 text-xs">{a.text}</p>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="flex items-center gap-2 bg-zinc-800 border border-zinc-700 rounded-xl px-3 py-2">
                  <input
                    value={newComment}
                    onChange={(e) => setNewComment(e.target.value)}
                    onKeyDown={(e) => e.key === 'Enter' && sendComment()}
                    placeholder="Pridať komentár..."
                    className="flex-1 bg-transparent text-zinc-300 text-xs placeholder:text-zinc-600 outline-none"
                  />
                  <button onClick={sendComment} className="w-7 h-7 flex items-center justify-center rounded-lg bg-orange-500 hover:bg-orange-600 transition-all cursor-pointer flex-shrink-0">
                    <i className="ri-send-plane-fill text-white text-xs" />
                  </button>
                </div>
              </div>
            </div>
          </AdminDrawer>
        );
      })()}
    </div>
  );
}
